/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RDSDbSubnet { 
    subnet_description?: string;
    subnet_name: string;
    subnet_status?: string;
}

